
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTask } from '../models/work-task';
import { WorkProject } from '../models/work-project';
import { WorkContact } from '../models/work-contact';
import { WorkContactPerson } from '../models/work-contact-person';
import { WorkTaskChangeRequestStatusEnum } from '../models/work-task-change-request-status-enum';

export function getTaskChangeRequestFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    created: new FormControl<string | undefined>(undefined),
    modified: new FormControl<string | undefined>(undefined),
    taskId: new FormControl<number | undefined>(undefined, [Validators.required]),
    task: new FormControl<WorkTask | undefined>(undefined),
    projectId: new FormControl<number | undefined>(undefined, [Validators.required]),
    project: new FormControl<WorkProject | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    contact: new FormControl<WorkContact | undefined>(undefined),
    contactPersonId: new FormControl<number | undefined>(undefined),
    contactPerson: new FormControl<WorkContactPerson | undefined>(undefined),
    fieldName: new FormControl<string | undefined>('', [Validators.required]),
    oldValue: new FormControl<string | undefined>(undefined),
    newValue: new FormControl<string | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    status: new FormControl<WorkTaskChangeRequestStatusEnum | undefined>(undefined, [Validators.required]),
    resolvedByUserId: new FormControl<number | undefined>(undefined),
    resolvedAt: new FormControl<string | undefined>(undefined),
    resolvedNotes: new FormControl<string | undefined>(undefined),
    createdBy: new FormControl<number | undefined>(undefined),
})
;
}
      